// Copyright (c) 2019 Celadon Development LLC, All rights reserved.
// Author Yana Sidorova <yana.sidorova@celadon.ae>
import React, { Component } from 'react';
import MediaQuery from 'react-responsive';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import uuidv4 from 'uuid/v4';
import { Link } from 'react-router-dom';

import history from '../../../../services/history';
import logo from '../../../../images/home-logo.svg';
import styles from './styles.js';
import Button from '../../../Button/Button';
import MobileMenu from '../../components/MobileMenu';

class HomeHeader extends Component {
  static propTypes = {
    classes: PropTypes.object,
    data: PropTypes.arrayOf(PropTypes.shape({
      type: PropTypes.string,
      menu: PropTypes.arrayOf(PropTypes.shape({
        label: PropTypes.string,
        link: PropTypes.string,
      })),
    })),
  };

  static defaultProps = {
    classes: {},
    data: [{
      type: 'leftMenu',
      menu: [{
        label: 'no link',
        link: '/',
      }],
    }],
  };

  getLinkLeft = (data) => {
    const { classes } = this.props;

    return (
      <div key={uuidv4()} className={classes.linkContainer}>
        <Link className={classes.link} to={data.link}>
          {data.label}
        </Link>
      </div>
    );
  }

  render() {
    const { classes, data } = this.props;
    const leftMenu = data.find(e => e.type === 'leftMenu').menu;

    return (
      <header className={classes.header}>
        <div className={classes.logoContainer}>
          <MediaQuery maxWidth={1150}>
            <div className={classes.menuIconContainer}>
              <MobileMenu leftMenu={leftMenu} />
            </div>
          </MediaQuery>
          <Link to={'/'} className={classes.logo}>
            <img className={classes.logoImage} src={logo} alt={'logo'} />
          </Link>
        </div>
        <MediaQuery minWidth={1151}>
          <div className={classes.menuContainer}>
            {leftMenu.map(item => this.getLinkLeft(item))}
          </div>
        </MediaQuery>
        <div style={{ display: 'flex' }}>
          <Button
            text={'Sell an item'}
            onPress={() => history.push('/basket')}
            style={classes.buttonStyle}
            isMainButton
            upperCase={false}
          />
          <Button
            text={'Login'}
            onPress={() => history.push('/login')}
            style={classes.loginButtonStyle}
            isMainButton
            upperCase={false}
          />
        </div>
      </header>
    );
  }
}


export default (withStyles(styles)(HomeHeader));
